import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import Services from '../services';

const HR_INFORMATION_OPTIONS = {
  hr: (slug?: string, openModal?: () => void) => [
    {
      icon: <EditIcon />,
      label: 'Edit Information',
      clickHandler: openModal,
      type: 'action',
    },

    {
      icon: <PictureAsPdfIcon />,
      label: 'Download PDF',
      link: `${Services.api.hr.downloadInformationPDF(slug)}`,
      type: 'download',
    },

    {
      icon: <DescriptionIcon />,
      label: 'Generate COE',
      link: `${Services.api.hr.generateCOE(slug)}`,
      type: 'download',
    },
  ],

  hrFinalized: (slug?: string) => [
    {
      icon: <PictureAsPdfIcon />,
      label: 'Download PDF',
      link: `${Services.api.hr.downloadInformationPDF(slug)}`,
      type: 'download',
    },

    {
      icon: <DescriptionIcon />,
      label: 'Generate COE',
      link: `${Services.api.hr.generateCOE(slug)}`,
      type: 'download',
    },
  ],

  hrbp: (slug?: string) => [
    {
      icon: <PictureAsPdfIcon />,
      label: 'Download PDF',
      link: `${Services.api.hr.downloadInformationPDF(slug)}`,
      type: 'download',
    },
  ],
};

export const hrInformationOptions = (user: string, slug?: string, openModal?: () => void) => {
  switch (user) {
    case 'hr':
      return HR_INFORMATION_OPTIONS.hr(slug, openModal);
    case 'hrFinalized':
      return HR_INFORMATION_OPTIONS.hrFinalized(slug);
    case 'hr-bp':
      return HR_INFORMATION_OPTIONS.hrbp(slug);
  }
};
